/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/authenticationMethod/AuthenticationMethodPanel" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Link } from "VSSUI/Link";
import { BasePanel } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanel";
import { IAuthenticationMethodPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/authenticationMethod/AuthenticationMethodPanel.Props";
import { Panel } from "Wit/Settings/BoardsExternalIntegration/components/panels/Panel.enum";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";
import { GitHubIntegrationCIActions, publishGitHubIntegrationTelemetry } from "Wit/Settings/BoardsExternalIntegration/telemetry/GitHub";

export class AuthenticationMethodPanel extends VssComponent<IAuthenticationMethodPanelProps, {}, IVssComponentContext> {
    public render() {
        return (
            <BasePanel
                onDismiss={this.props.onDismiss}
                title={Resources.EnterpriseAuthenticationMethod_Title}
                onRenderHeaderContent={this._renderHeader}
                className="authentication-method-panel"
            >
                <div className="authentication-method-panel-content">
                    <div className="authentication-method-panel-button-container">
                        <Button
                            className="authentication-method-panel-button"
                            primary={true}
                            text={Resources.OAuth}
                            onClick={this._onOAuthClick}
                            disabled={this.props.disableOAuth}
                        />
                    </div>
                    <div className="authentication-method-panel-alternative-message">{Resources.NewConnection_alternative_ghe_message}</div>
                    <div className="authentication-method-panel-pat-message">
                        <Link href="#" className="new-connection-link" onClick={this._onPatClick}>
                            {Resources.PAT}
                        </Link>
                    </div>
                    <div className="authentication-method-panel-pwd-message">
                        <Link href="#" className="new-connection-link" onClick={this._onCredentialsClick}>
                            {Resources.UsernameAndPassword}
                        </Link>
                    </div>
                </div>
            </BasePanel>
        );
    }

    private readonly _renderHeader = (): JSX.Element => {
        return <div>{Resources.EnterpriseAuthenticationMethod_Text}</div>;
    };

    private readonly _onOAuthClick = (): void => {
        this.props.showPanel(Panel.EnterpriseOAuth);
        publishGitHubIntegrationTelemetry(this.context, GitHubIntegrationCIActions.ADMIN_NEW_CONNECTION_OAUTH_ENTERPRISE);
    };

    private readonly _onPatClick = (): void => {
        this.props.showPanel(Panel.EnterprisePat);
        publishGitHubIntegrationTelemetry(this.context, GitHubIntegrationCIActions.ADMIN_NEW_CONNECTION_PAT_ENTERPRISE);
    };

    private readonly _onCredentialsClick = (): void => {
        this.props.showPanel(Panel.EnterpriseCredentials);
        publishGitHubIntegrationTelemetry(this.context, GitHubIntegrationCIActions.ADMIN_NEW_CONNECTION_CREDENTIALS_ENTERPRISE);
    };
}
